import React from 'react';
//import todo from './img/sigong_nav/nav_calendar.png';
import todo from './img/sigong_nav/abys1.png';
//import saleManage from './img/sigong_nav/nav_sales.png';
import saleManage from './img/sigong_nav/abys2.png';
//import todayTodo from './img/sigong_nav/nav_today.png';
import todayTodo from './img/sigong_nav/abys3.png';
//import product from './img/sigong_nav/nav_order.png';
import product from './img/sigong_nav/abys4.png';
//import store from './img/sigong_nav/nav_store.png';
import store from './img/sigong_nav/abys5.png';
import { Link } from 'react-router-dom';
import {resetSession} from './../src/common';
function Bottom_menu() {

    const botFix = {
        position: 'fixed',
        bottom: '0',
        left:'0',
        boxShadow: '#dddddd 0px 0px 15px 5px',
        width: '100%',
        padding: '10px 0',
        backgroundColor: '#fff',
        zIndex: '999'
    }
    const imgSize = {
        width: '35px',
        height: '35px'
    }
    const textStyle = {
        fontSize: '12px',
        whiteSpace: 'nowrap',
        paddingTop: '3px',
        color: '#A0A1A1',
        fontWeight:'bold'
    }
    const boxStyle = {
        width: '20%',
        float: 'left',
        textAlign: 'center'
    }
    const onClick = () =>{
        alert('서비스 준비중입니다.');
    }

    return (
        <>
            <div className="" style={botFix}>
                <div className="w-100">
                    <Link to="/calendarchoice">
                        <div className="" style={boxStyle}>
                            <img src={todo} style={imgSize} />
                            <div style={textStyle}>일정관리</div>
                        </div>
                    </Link>
                    <Link to="/maechul-list" onClick={resetSession}>
                        <div className="" style={boxStyle}>
                            <img src={saleManage} style={imgSize} />
                            <div style={textStyle}>정산관리</div>
                        </div>
                    </Link>
                    
                    <Link to="/sigong_list" onClick={resetSession}>
                        <div className="" style={boxStyle}>
                            <img src={todayTodo} style={imgSize} />
                            <div style={textStyle}>오늘일정</div>
                        </div>
                    </Link>
                    <Link to="#" onClick={() => alert('준비중입니다.')}>
                        <div className="" style={boxStyle} >
                            <img src={product} style={imgSize} />
                            <div style={textStyle}>상품주문</div>
                        </div>
                    </Link>
                    
                    <Link to="/storeManage">
                        <div className="" style={boxStyle}>
                            <img src={store} style={imgSize} />
                            <div style={textStyle}>지점관리</div>
                        </div>
                    </Link>
                </div>
            </div>

        </>
    )
}

export default Bottom_menu;